// src/components/shared/MotusButton.js
//
// React wrapper around the motus-buttons.css classes.
// Maps props to the correct CSS class combinations.

import React from 'react';
import MotusSpinner from './MotusSpinner';

/**
 * @param {object} props
 * @param {'primary'|'primary-pill'|'secondary'|'ghost'|'danger'|'success'|'icon'|'icon-sq'|'upload'} [props.variant='primary']
 * @param {'sm'|'md'|'lg'} [props.size='md']
 * @param {boolean} [props.loading=false]
 * @param {boolean} [props.disabled=false]
 * @param {React.ReactNode} [props.icon] — icon element (left side)
 * @param {React.ReactNode} [props.children] — button label
 * @param {string} [props.className] — additional classes
 * @param {object} [props.style] — additional inline styles
 * @param {function} [props.onClick]
 * @param {string} [props.type='button']
 */
function MotusButton({
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled = false,
  icon,
  children,
  className = '',
  style,
  onClick,
  type = 'button',
  ...rest
}) {
  const isDisabled = disabled || loading;

  // Build class list
  const classes = [
    'm-btn',
    loading ? 'm-btn-loading' : `m-btn-${variant}`,
    size !== 'md' ? `m-btn-${size}` : '',
    isDisabled && !loading ? 'm-disabled' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <button
      type={type}
      className={classes}
      style={style}
      onClick={isDisabled ? undefined : onClick}
      disabled={isDisabled}
      {...rest}
    >
      {loading ? (
        <>
          <MotusSpinner size={16} color="#fff" />
          {children && <span>{children}</span>}
        </>
      ) : (
        <>
          {icon && <span style={{ display: 'inline-flex', alignItems: 'center' }}>{icon}</span>}
          {children}
        </>
      )}
    </button>
  );
}

export default MotusButton;
